export default {
  complete: 4,
  credit: 1,
  credit_business: 2,
  credit_business_est_debts: 3,
  credit_interim: 2,
  credit_personal: 2,
  credit_personal_interim: 3,
  credit_business_personal: 3,
  credit_business_interim: 3
}
